module.exports = __webpack_public_path__ + "static/media/404-notfound.37df71f7.png";